import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeftBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 10,
	viewBox: "0 0 16 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.12269 9.72437C6.41519 9.43187 6.41519 8.95937 6.12269 8.66687L3.2202 5.74937H14.5977C15.0102 5.74937 15.3477 5.41187 15.3477 4.99937C15.3477 4.58687 15.0102 4.24937 14.5977 4.24937H3.2202L6.1302 1.33937C6.4227 1.04687 6.4227 0.574375 6.1302 0.281875C5.8377 -0.010625 5.3652 -0.010625 5.0727 0.281875L0.872695 4.47438C0.580195 4.76688 0.580195 5.23938 0.872695 5.53188L5.0652 9.72437C5.3577 10.0094 5.8377 10.0094 6.12269 9.72437Z",
		fill: "#3C59F6"
	})
});
export default SvgArrowLeftBack;
